<h3 [innerHTML]="'ONSIP_I18N.RULES_SHOW_STRONGSAYSOSTRONG_IF' | translate"></h3>
<p
  [innerHTML]="
    'ONSIP_I18N.RULES_TELL_US_WHAT_URLS_THE_STRONGSAYSOSTRONG_BUTTON_SHOULD_APPEAR_ON_THIS_ONLY_APPLIES_TO_PAGES_THAT_YOU_OWN'
      | translate
  "
></p>
<onsip-page-rule-picker
  class="rule-picker"
  [verbs]="ruleTypes"
  [initialValues]="rulesArray"
  (pageRuleFormInit)="onPageRuleFormInit($event, 'rules')"
  type="rule"
></onsip-page-rule-picker>

<h3 [innerHTML]="'ONSIP_I18N.EXCEPTIONS_DO_NOT_SHOW_STRONGSAYSOSTRONG_IF' | translate"></h3>
<p
  [innerHTML]="
    'ONSIP_I18N.EXCEPTIONS_SPECIFY_URLS_WHERE_YOU_DO_NOT_WANT_THE_STRONGSAYSOSTRONG_BUTTON_TO_APPEAR_EXCEPTIONS_ALWAYS_OVERRIDE_RULES'
      | translate
  "
></p>
<onsip-page-rule-picker
  [verbs]="exceptionTypes"
  [initialValues]="exceptionsArray"
  (pageRuleFormInit)="onPageRuleFormInit($event, 'exceptions')"
  type="exception"
></onsip-page-rule-picker>
